import { render, staticRenderFns } from "./Memoize.vue?vue&type=template&id=2edc99fe&"
import script from "./Memoize.vue?vue&type=script&lang=js&"
export * from "./Memoize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports